import tw from 'twin.macro';

export const PageWrapper = tw.div`relative bg-gray-100 md:bg-white
pt-16 lg:px-20 px-4 overflow-x-hidden font-display h-screen`;

export const TimetableWrap = tw.div`bg-white -mt-4 lg:pb-8 pb-4 lg:pt-20! pt-10! px-2 lg:px-4`;

export const PageHeaderWrap = tw.div`lg:w-5/7 flex items-center justify-between lg:ml-10 mb-4`;

export const Title = tw.h4`text-center lg:text-xl text-lg uppercase
 lg:py-8 md:py-6 py-4 font-semibold`;

export const Row = tw.div`lg:w-7/12 mx-auto flex justify-between py-2 md:py-4
 border-b border-gray-300 lg:py-8 last:border-none`;

export const Details = tw.ul`lg:text-xl text-sm font-semibold`;

export const DetailItem = tw.li`lg:my-1`;

export const DetailItemkey = tw.span`text-primary`;

export const DetailItemValue = tw.span``;

export const QRcode = tw.img`lg:w-52 lg:h-52 w-20 h-24`;

export const PrintButton = tw.div`absolute text-white lg:bottom-16 lg:right-50 
bottom-[5.5rem] right-6 font-bold fixed`;
